<template>
  <div class="slide-menu-wrapper">
    <FriedIconButton
      v-if="showCloseButton"
      class="close-button"
      data-external="dsr-close-navigation-slide-menu"
      @click="$emit('hide-slide-menu')"
    >
      <FriedIcon icon="close" />
    </FriedIconButton>
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SlideMenuWrapper',
  props: {
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['hide-slide-menu'],
});
</script>
<style lang="scss" scoped>
.slide-menu-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: $z1;
  display: flex;
  height: 100%;

  .close-button {
    background-color: var(--base-blue);
    color: var(--white);
    box-shadow: var(--shadow-4);
    margin-top: var(--spacing-50);
    margin-right: var(--spacing-100);

    &:hover,
    &:focus {
      background-color: var(--gray-30);
    }

    &.active {
      background-color: var(--gray-39);

      &:hover {
        background-color: var(--gray-49);
      }
    }
  }
}
</style>
